var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "import",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.252,
    height: 15.193,
    viewBox: "0 0 15.252 15.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7017",
    "data-name": "Path 7017",
    d: "M12.411,16.464H9.879v1.5h2.532c.753,0,1.338.384,1.338.715v6.663c0,.331-.584.716-1.338.716H2.84c-.753,0-1.337-.385-1.337-.716V18.683c0-.331.584-.716,1.337-.716H5.372v-1.5H2.84c-1.592,0-2.84.974-2.84,2.218v6.663c0,1.244,1.247,2.218,2.84,2.218h9.572c1.592,0,2.84-.974,2.84-2.218V18.683C15.251,17.438,14,16.464,12.411,16.464Z",
    transform: "translate(0 -12.37)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7018",
    "data-name": "Path 7018",
    d: "M23.82,7.351a.749.749,0,0,0-.531.22l-.941.94V.868a.751.751,0,0,0-1.5,0V8.562l-.991-.991a.751.751,0,1,0-1.062,1.062l2.243,2.243a.748.748,0,0,0,.531.22h.011a.747.747,0,0,0,.531-.22l2.243-2.243a.751.751,0,0,0-.531-1.282Z",
    transform: "translate(-13.921 -0.117)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.ac5f0017c67faf44ebcbbeb2a2678cdb.svg";
export { ForwardRef as ReactComponent };